import styles from './CategoryProductsSection.module.css';
import { NavLink } from '@/components/ui';
import { ProductTile } from '../../productTile';
import { ICategoriesArray, IMarketPlaceProduct } from '@/interfaces';
import { useGlobalContext } from '@/lib/context';
import { formatToIndianCurrency, pushRoute } from '@/lib/helpers/common';
import { DynamicElementType } from '@/lib/constants';
type props = {
    products: ICategoriesArray
    catSlug: string
    backgroundColor?: string
    elementType?: DynamicElementType
    isFirstCat?: Boolean
}
export function CategoryProductsSection({ products, catSlug, backgroundColor, elementType, isFirstCat }: props) {
    const baseUrl = process.env.SITE_URL;
    const { props: { pageURL, isMobileView } } = useGlobalContext();
    const isHomePage = pageURL === `${baseUrl}/online-store`;
    if (!products || !products.products || products.products.length == 0) return;
    return (
        <div className={styles.sectionMaoinbox} style={{ background: backgroundColor }}>
            <div className={`${styles.containerFull} containerFull`}>
                <div className={styles.headingMinbox}>
                    <div className={styles.heaSubheadbox}>
                        {
                            products.productCount ?
                                <NavLink href={`${baseUrl}/online-store/${catSlug}/${products.categorySlug}`}> <h2 className="font16 text222 fbold mb10">{products.categoryName}</h2></NavLink>
                                : <h2 className="font16 text222 fbold mb10">Similar Products</h2>
                        }
                    </div>
                </div>
                <div className={styles.productGridBox}>
                    {products?.products?.map((f: IMarketPlaceProduct, idx: number) =>
                        <ProductTile product={f} isFirstCatAndProduct={isFirstCat && (isMobileView ? idx <= 1 : idx <= 3)} key={f.productId} elementType={elementType} />
                    )}
                </div>
                {
                    (products.productCount && Number(products.productCount) > (isHomePage ? 4 : 8)) &&
                    <div className={styles.moreOptions} onClick={() => pushRoute(`${baseUrl}/online-store/${catSlug}/${products.categorySlug}`)}>
                        <div className={styles.morOptiner}>
                            <span className="textpink font16 fbold">{products.productCount && Number(products.productCount) - 1}+ Options, Starts from ₹{formatToIndianCurrency(products.lowestPrice)}</span>
                            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M7.256.751a.888.888 0 0 1 1.238 0l5.25 5.143a.845.845 0 0 1 0 1.212l-5.25 5.143a.888.888 0 0 1-1.238 0 .845.845 0 0 1 0-1.212l3.757-3.68H.875A.866.866 0 0 1 0 6.5c0-.473.392-.857.875-.857h10.138l-3.757-3.68a.845.845 0 0 1 0-1.212z" fill="#EB5976" />
                            </svg>
                        </div>

                    </div>
                }
            </div>
        </div >

    )
}